// extracted by mini-css-extract-plugin
export var clauseRow = "_3g-6";
export var emptyState = "_3g-b";
export var filterContent = "_3g-a";
export var filterGroup = "_3g-1";
export var filterGroupContainer = "_3g-0";
export var nestedGroup = "_3g-2";
export var nestedGroupDepth1 = "_3g-3";
export var nestedGroupDepth2 = "_3g-4";
export var nestedGroupDepth3 = "_3g-5";
export var operatorAnd = "_3g-8";
export var operatorOr = "_3g-9";
export var operatorToggle = "_3g-7";
export var removeGroupButton = "_3g-c";